module.exports = __webpack_public_path__ + "static/media/linkedin.576dd0ba.svg";